import { render } from "./ActiveList.vue?vue&type=template&id=0a59c45a"
import script from "./ActiveList.vue?vue&type=script&lang=js"
export * from "./ActiveList.vue?vue&type=script&lang=js"

import "./ActiveList.vue?vue&type=style&index=0&id=0a59c45a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__